import { Component } from '@angular/core';

@Component({
    selector: 'app-user-management',
    standalone: false,
    templateUrl: './user-management.component.html',
    styleUrl: './user-management.component.scss',
})
export class UserManagementComponent {}
